/*
==== breadcrumbs JavaScript directive ====

Setup in Router breadcrumbsConfig options
* See jv.Admin.js
$scope.breadcrumbs = {
    backText: 'Go back to:',
    previousText: 'Previous',
    menuText: 'Menu',
    links: [
        {
            linkText: '', // Default text for the breadcrumb
            link: '', // breadcrumb route path
            title: '', // If not present then use the linkText
            target: '' // defaults to _self
        }
    ]
}

<!-- How to implement the breadcrumbs -->
<section breadcrumbs="breadcrumbsConfig"></section>
<script type="text/javascript" src="${jsCdnHost}/__assets__/stylekit/js/jv.Breadcrumbs.js?v=${fileVersion}"></script>

Notes:
* Always show the last item from the breadcrumbs link (current page)
* clicking on the back arrow will take you to the previous page in the hierarchy
* Sub-menu shows on hover / click on mobile
* if at the foremost page (only a single page in the array) then show the menu options as disabled
* if at the foremost page (only a single page in the array) then show the back arrow as disabled
* By default if there are more than 1 link, add "Go back to:" text under the breadcrumb text
* Goes in reverse order top down (newest on top, oldest on bottom)
* Config can be overwritten /modified in controller
* Generic text supported for non-i18n pages
*/
angular.module('jv.Common.Directives.Breadcrumbs', [])
    .controller('breadcrumbController', [
        '$scope',
        '$window',
        function($scope, $window) {
            if ($scope.breadcrumbs && $scope.breadcrumbs.links) {
                // preserve passed‐in links
                $scope.breadcrumbs.links = $scope.breadcrumbs.links.slice();
            }

            $scope.goToPreviousLink = function(param) {
                if (param.isConfirmationRequired) {
                    var confirmed = window.confirm(i18n['ADMIN_REQUISITION_UNSAVED_CHANGES']);
                    if (confirmed) {
                        $window.location.href = param.link;
                    }
                } else {
                    $window.location.href = param.link;
                }
            };

            $scope.backText = (window.i18n && window.i18n.GO_BACK_TO)
                ? window.i18n.GO_BACK_TO
                : 'Go back to:';
        }
    ])
    .directive('breadcrumbs', [function() {
        return {
            transclude: true,
            restrict: 'A',
            scope: {
                breadcrumbs: '='
            },
            templateUrl: '/__assets__/stylekit/templates/breadcrumbs.html'
        };
    }]);
